import { Outlet, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Video } from 'lucide-react';

export const StudioLayout = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gray-950 text-white">
            {/* Studio Header */}
            <header className="h-16 border-b border-white/10 bg-gray-900/95 backdrop-blur-sm" data-testid="studio-header">
                <div className="flex items-center justify-between h-full px-4">
                    <div className="flex items-center gap-4">
                        <Button
                            variant="ghost"
                            size="sm"
                            onClick={() => navigate('/')}
                            className="text-white/70 hover:text-white hover:bg-white/10"
                            data-testid="back-to-dashboard"
                        >
                            <ArrowLeft className="w-4 h-4 mr-2" />
                            Exit Studio
                        </Button>
                        <div className="flex items-center gap-2">
                            <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center">
                                <Video className="w-5 h-5 text-white" />
                            </div>
                            <span className="text-lg font-semibold">StreamHub Studio</span>
                        </div>
                    </div>
                </div>
            </header>

            {/* Studio Content */}
            <Outlet />
        </div>
    );
};

export default StudioLayout;
